import React, { useEffect, useState } from "react"
import { IFloatingRateDto } from "../../../../types/company/IFloatingRateDto"
import * as TrinityAPI from "../../../../requests/TrinityAPI"
import { RatePopUp } from "./RatePopUp"
import { IModalMessage } from "../../../../types/error/IModalMessage"
import { ModalPopUp } from "../../../common/element/ModalPopUp"
import { spacedNum } from "../../../common/CommonHelper"
import { useStore } from "../../../../stores/RootStoreContext"

export const FloatingRates: React.FC<{ rateType: string }> = ({ rateType }) => {
  const { userStore } = useStore()
  const [rates, setRates] = useState<IFloatingRateDto[]>([])
  const [rate, setRate] = useState<IFloatingRateDto | undefined>()
  const [popUpVisibility, setPopUpVisibility] = useState(false)
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)

  useEffect(() => {
    getRates()
  }, [])

  const getRates = () => {
    TrinityAPI.getBaseRate(rateType, response => {
      if (response.status === 200) {
        setRates(response.data)
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка получения данных с сервера: " + response.data.message })
      }
    })
  }

  const deleteRate = (rateId: string | undefined) => {
    if (!rateId) return

    TrinityAPI.deleteBaseRate(rateId, response => {
      if (response.status === 200) {
        getRates()
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка при удалении ставки: " + response.data.message })
      }
    })
  }

  const showPopUp = (currentRate: IFloatingRateDto | undefined) => {
    if (!currentRate) {
      currentRate = { type: rateType }
    }
    setRate(currentRate)
    setPopUpVisibility(true)
  }

  const hidePopUp = () => {
    getRates()
    setRate(undefined)
    setPopUpVisibility(false)
  }

  const getHeading = () => {
    switch (rateType) {
      case "AMOUNT":
        return "От суммы платежа"
      case "VOLUME":
        return "По сумме инвойса по объему месячному"
      default:
        return "От месячного оборота"
    }
  }

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <div className="form-block-popup">
        <h4 className="heading-chapter">{getHeading()}</h4>
        {rates.map((r, index) => (
          <div className="flex-row-24" key={index}>
            <div className="condition" onClick={() => (userStore.isAdmin ? showPopUp(r) : void 0)}>
              {`${r.operator} ${spacedNum(r.amount || 0)} USD = ${r.rate}% ${
                r.onTopAmount ? `+ ${r.onTopAmount} USD` : ""
              }`}
            </div>
            {userStore.isAdmin && <div className="delete-button" onClick={() => deleteRate(r.id)} />}
          </div>
        ))}
        {userStore.isAdmin && (
          <div className="button-file" onClick={() => showPopUp(undefined)}>
            Добавить ставку
          </div>
        )}
      </div>
      {popUpVisibility && <RatePopUp rate={rate} hidePopUp={hidePopUp} />}
    </>
  )
}
